<template>
	<date-picker
		:class="{ 'date-component-round': round }"
		:disabled="disabled"
		:disabled-date="disabledPastDates"
		:value="date"
		:editable="disableEdit"
		placeholder="dd/mm/aaaa"
		format="DD/MM/YYYY"
		value-type="YYYY-MM-DD"
		@input-error="$emit('on-input-error', $event)"
		@input="$emit('on-input', $event)"
		@clear="$emit('clear', $event)"
	>
		<template v-if="showIcon">
			<img
				class="icon-calendar-custom"
				slot="icon-calendar"
				:src="icon"
			/>
		</template>
	</date-picker>
</template>

<script>
	import DatePicker from 'vue2-datepicker';
	import 'vue2-datepicker/index.css';
	import 'vue2-datepicker/locale/es';

	function disabledPastDates(date) {
		if (this.disabledPastDate) {
			return date < new Date();
		} else if (this.disabledLaterDate) {
			return date > new Date();
		}
		return false;
	}

	export default {
		name: 'date-component',
		components: {
			DatePicker,
		},
		methods: {
			disabledPastDates,
		},
		props: {
			date: [Date, String],
			disabled: {
				default: false,
				type: Boolean,
			},
			icon: String,
			round: {
				default: false,
				type: Boolean,
			},
			showIcon: {
				default: true,
				type: Boolean,
			},
			disabledPastDate: {
				default: false,
				type: Boolean,
			},
			disableEdit: {
				default: true,
				type: Boolean,
			},
			disabledLaterDate: {
				default: false,
				type: Boolean,
			},
		},
	};
</script>

<style lang="scss" scoped>
	.icon-calendar-custom {
		height: 20px;
		width: 20px;
		padding-top: 2px;
	}
</style>


// WEBPACK FOOTER //
// src/components/shared/date-component/date-component.vue